// Generated by CoffeeScript 1.9.2
var merge,
  slice = [].slice;

merge = require('./merge');

module.exports = function() {
  var args;
  args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  return args.reduce(function(a, b) {
    var key, query, res;
    res = {};
    for (key in a) {
      query = a[key];
      res[key] = query;
    }
    for (key in b) {
      query = b[key];
      if (res[key] != null) {
        res[key] = merge(res[key], query);
      } else {
        res[key] = query;
      }
    }
    return res;
  });
};
